import React from 'react';
import root from 'window-or-global';
import {svgs} from 'epic-diesel-common/src/constants';
import {Icon, Message, Link} from 'epic-diesel-common';
import {NavLink} from 'react-router-dom';
import {generateRoutePath} from 'epic-common/src/route';
import Locale from '../../header/Locale';
import withPageDirection from '../../../hocs/withPageDirection';

//@ts-ignore
import styles from './ApplicationHeader.pcss';

interface Props {
    code?: string;
    redirectPath?: string;
    userState: Record<string, any>;
}

const ApplicationHeader = ({
    code = 'epic.affiliate.signup.header',
    redirectPath = 'overview',
    userState
}: Props) => {
    const {accountInfo} = userState || {};
    const {isLoggedIn, displayName} = accountInfo || {};

    return (
        <div className={styles.headerWrapper}>
            <div className={styles.left}>
                <NavLink to={generateRoutePath(redirectPath)}>
                    <Icon
                        className={styles.back}
                        icon={svgs.ARROW}
                        fontSize="small"
                        flip="horizontal"
                    />
                </NavLink>

                <Message code={code} className={styles.title} />
            </div>
            <div className={styles.right}>
                <div className={styles.user}>
                    {isLoggedIn && (
                        <>
                            <span>{displayName}</span>
                            <Link
                                to="/logout"
                                isExternalUrl={true}
                                onClick={() => {
                                    if (root.sessionStorage) {
                                        root.sessionStorage.clear();
                                    }
                                }}>
                                <Message code="epic.affiliate.common.signout" />
                            </Link>
                        </>
                    )}
                </div>
                <Locale />
            </div>
        </div>
    );
};

export default withPageDirection(ApplicationHeader);
